<template>
  <div id="Wizualizacja">
    <div class="wrapper">
      <div class="container">
        <div
          class="canvas-container"
          style="background-size: contain; background-repeat: no-repeat"
        >
          <!-- <canvas id="obudowa" width="640" height="640" ref="canRef"></canvas>

          <canvas id="centrala" width="640" height="640"></canvas>

          <canvas id="modul" width="640" height="640"></canvas> -->

          <div id="stage" style="width:auto; height:100%"></div>
        </div>
      </div>
    </div>

    <!-- <br>
    <br>
    <input type="number" v-model="odchylkaX" @input="test" />
    <input type="number" v-model="odchylkaY" @input="test" />
    <input type="number" v-model="odchylkaKat" @input="test" step="1" max="90" min="0"/>
    <br>
    <br> -->
  </div>
</template>

<script>
const width = 640; // window.innerWidth;
const height = 640; // window.innerHeight;
import { mapGetters } from "vuex";

export default {
  name: "Wizualizacja",
  props: ["obudowa", "plytka", "modul", "modulIndex", "eyes","widok", "widokBtn"],
  data() {
    return {
      msg: "Montaż central",
      canvas: null,
      centrala: {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
      },
      configHoles: {
        name: 'hole',
        x: 0,
        y: 0,
        radius: 4,
        fill: 'red',
        stroke: '#fff',
        strokeWidth: 2,
      },
      odchylkaX: 0,
      odchylkaY: 0,
      odchylkaKat: 0,
      katTmp: 0,
      mySVG: require("../assets/AWO000.svg"),
    };
  },
  directives: {
    // loadImage(canvasElement, binding,vnode) {
    // 	vnode.context.canvas = canvasElement
    //   const ctx = canvasElement.getContext('2d')
    //   const image = new Image()
    //   image.src = '../assets/awo000.jpg'
    //   image.onload = () => {
    //     ctx.drawImage(image, 0, 0, 500, 500)
    //   }
    // }
  },
  computed: {
    ...mapGetters("products", [
      "inputData",
      "modulSelected",
      "selectedElements",
    ]),
    compIndexModul() {
      return this.modulIndex;
    },
  },
  watch: {
    selectedElements(newValue, oldValue) {
      // console.log ('selectedElements', newValue, oldValue)
      this.viewMontaz();
    },
    odchylkaKat() {
      this.viewMontaz();
    },
    eyes(newValue, oldValue) {
      this.viewMontaz();
    },
    widok(newValue, oldValue) {
      if (this.widokBtn) {
        this.viewMontaz();
      }
    }
  },
  methods: {
    test() {
      // this.viewMontaz(this.obudowa);
    },
    clearCanvas() {
      // var co = document.getElementById("obudowa");
      // var oCtx = co.getContext("2d");
      // oCtx.width = window.innerWidth;
      // oCtx.height = window.innerHeight;
      // oCtx.clearRect(0, 0, co.width, co.height);
      // var cp = document.getElementById("centrala");
      // var cCtx = cp.getContext("2d");
      // cCtx.width = window.innerWidth;
      // cCtx.height = window.innerHeight;
      // cCtx.clearRect(0, 0, cp.width, cp.height);
      // var cm = document.getElementById("modul");
      // var mCtx = cm.getContext("2d");
      // mCtx.width = window.innerWidth;
      // mCtx.height = window.innerHeight;
      // mCtx.clearRect(0, 0, cm.width, cm.height);
    },
    clearCanvasCentrala() {
      // var co = document.getElementById("obudowa");
      // if (co !== null) {
      //   var oCtx = co.getContext("2d");
      //   oCtx.width = window.innerWidth;
      //   oCtx.height = window.innerHeight;
      //   oCtx.clearRect(0, 0, co.width, co.height);
      // }
    },
    clearCanvasCentrala() {
      // var cp = document.getElementById("centrala");
      // if (cp !== null) {
      //   var cCtx = cp.getContext("2d");
      //   cCtx.width = window.innerWidth;
      //   cCtx.height = window.innerHeight;
      //   cCtx.clearRect(0, 0, cp.width, cp.height);
      // }
    },
    clearCanvasModule() {
      // var cm = document.getElementById("modul");
      // if (cm !== null) {
      //   var mCtx = cm.getContext("2d");
      //   mCtx.width = window.innerWidth;
      //   mCtx.height = window.innerHeight;
      //   mCtx.clearRect(0, 0, cm.width, cm.height);
      // }
    },
    draw(ev) {
      const x = ev.offsetX;
      const y = ev.offsetY;
      // console.log(x, y);
    },
    viewMontaz() {
      console.log('------ viewMontaz ------')
			const v = this;
      let wsp = 0;
      var modX = 0;
      var modY = 0;

      var kolorCentrala = ["255,0,0,0.5"];
      var kolorModul = [
        "64,82,182,0.5",
        "77,177,79,0.5",
        "255,192,9,0.5",
        "116,85,75,0.5",
      ];
      if (
        this.selectedElements &&
        Object.keys(this.selectedElements).length > 0
      ) {
        this.clearCanvas();

        var enclosures = this.selectedElements["obudowa"]
          ? Object.assign({}, this.selectedElements["obudowa"])
          : {};
        var controlPanel = this.selectedElements["centrala"]
          ? Object.assign({}, this.selectedElements["centrala"])
          : {};
        // var module = (this.selectedElements['moduly'] && this.selectedElements['moduly'][0]) ? Object.assign({}, this.selectedElements['moduly'][0]) : {}
        var modules = this.selectedElements["moduly"]
          ? Object.assign({}, this.selectedElements["moduly"])
          : {};

        var moveX = this.odchylkaX;
        var moveY = this.odchylkaY;
        var rotation = this.odchylkaKat;

        v.stage = new Konva.Stage({
          container: 'stage',
          width: width,
          height: height,
        });

        // --------------------------------------- Obudowa

        var layerObudowa = new Konva.Layer();
        var imageObj = new Image();
        imageObj.onload = function () {

          let loadedImageWidth = imageObj.width;
          let loadedImageHeight = imageObj.height;
          let scale_factor = Math.min(
            width / imageObj.width,
            height / imageObj.height
          );
          // console.log('scale_factor', scale_factor)

          let newWidth = imageObj.width * scale_factor;
          let newHeight = imageObj.height * scale_factor;

          var yoda = new Konva.Image({
            x: 0,
            y: 0,
            width: newWidth,
            height: newHeight,
            image: imageObj,
          });
          layerObudowa.add(yoda);
        };

        var path = ''
        if (this.widok) {
          var prefix =  (this.widok === 'C') ? '' : '_' + this.widok
          path = 'https://lib.pulsar.pl/img/montaz_central/' + enclosures['symbol'] + prefix + '.jpg'
        } else {
          path = 'https://lib.pulsar.pl/img/montaz_central/' + enclosures['symbol'] + '.jpg'
        }

        imageObj.src = path;
        v.stage.add(layerObudowa);

        let szerokoscObudowy = 0
        let wysokoscObudowy = 0

         if (this.widok === 'G' || this.widok === 'D') {
            szerokoscObudowy = Number(enclosures.szerokosc)
            wysokoscObudowy = Number(enclosures.glebokosc)
          } else if (this.widok === 'L' || this.widok === 'P') {
            szerokoscObudowy = Number(enclosures.glebokosc)
            wysokoscObudowy = Number(enclosures.wysokosc)
          } else {
            szerokoscObudowy = Number(enclosures.szerokosc)
            wysokoscObudowy = Number(enclosures.wysokosc)
          }

      // --------------------------------------- Centrala

        if (Object.keys(controlPanel).length > 0 && !this.eyes.includes("centrala")) {

          var layerCentrala = new Konva.Layer();

          if (controlPanel.scianka === this.widok) {

            let newCentralkaWidth = (layerObudowa.canvas.width * controlPanel.szerokosc) / szerokoscObudowy
            let newCentralkaHeight = (layerObudowa.canvas.height * controlPanel.wysokosc) / wysokoscObudowy

            // console.log('===========================')
            // console.log('layerObudowa.canvas.width', layerObudowa.canvas.width)
            // console.log('layerObudowa.canvas.height', layerObudowa.canvas.height)
            // console.log('-------------------------')
            // console.log('szerokoscObudowy', szerokoscObudowy)
            // console.log('wysokoscObudowy', wysokoscObudowy)
            // console.log('-------------------------')
            // console.log('controlPanel.szerokosc', controlPanel.szerokosc)
            // console.log('controlPanel.wysokosc', controlPanel.wysokosc)
            // console.log('-------------------------')
            // console.log('newCentralkaWidth', newCentralkaWidth)
            // console.log('newCentralkaHeight', newCentralkaHeight)
            // console.log('-------------------------')

            if (szerokoscObudowy >= wysokoscObudowy) {
              // wsp = layerObudowa.canvas.width / szerokoscObudowy;
              wsp = width / szerokoscObudowy; // dodane
              newCentralkaWidth = controlPanel.szerokosc * wsp;
              newCentralkaHeight = controlPanel.wysokosc * wsp; // dodane

            } else {
              // wsp = layerObudowa.canvas.height / wysokoscObudowy;
              wsp = height / wysokoscObudowy;
              newCentralkaHeight = controlPanel.wysokosc * wsp;
              newCentralkaWidth = controlPanel.szerokosc * wsp;
            }
            // console.log('wsp', wsp)
            // console.log('newCentralkaWidth', newCentralkaWidth)
            // console.log('newCentralkaHeight', newCentralkaHeight)
            // console.log('===========================')
            // let newCentralkaWidth =
            //   (layerObudowa.canvas.width * controlPanel.szerokosc) /
            //   enclosures.szerokosc;
            // let newCentralkaHeight =
            //   (layerObudowa.canvas.height * controlPanel.wysokosc) /
            //   enclosures.wysokosc;

            // if (enclosures.szerokosc >= enclosures.wysokosc) {
            //   wsp = layerObudowa.canvas.width / enclosures.szerokosc;
            //   layerObudowa.canvas.height = controlPanel.wysokosc * wsp;
            // } else {
            //   wsp = layerObudowa.canvas.height / enclosures.wysokosc;
            //   newCentralkaWidth = controlPanel.szerokosc * wsp;
            // }

            modX = controlPanel.wspX;
            modY = controlPanel.wspY;

            var pcbX =
              Number(modX * wsp) -
              Number(controlPanel.p1x * wsp) +
              Number(this.odchylkaX * wsp);
            var pcbY =
              Number(modY * wsp) -
              Number(controlPanel.p1y * wsp) +
              Number(this.odchylkaY * wsp);

            let centrala = new Konva.Group({
              name: 'centrala',
              x: Number(pcbX),
              y: Number(pcbY),
              width: Number(newCentralkaWidth),
              height: Number(newCentralkaHeight),
              draggable: false
            })
            .add (new Konva.Rect({
                x: Number(0),
                y: Number(0),
                width: Number(newCentralkaWidth),
                height: Number(newCentralkaHeight),
                fill: "rgba(" + kolorCentrala + ")"
              })
            )

            for (var no = 1; no < 7; no++) {
              if (
                Number(controlPanel["p" + no + "x"]) === 0 &&
                Number(controlPanel["p" + no + "y"]) === 0
              ) {
              } else {
                var pX =
                  Number(controlPanel["p" + no + "x"]) * Number(wsp); // + centralka[controlPanel].odchylkaX
                var pY =
                  Number(controlPanel["p" + no + "y"]) * Number(wsp);

                let h = new Konva.Circle(v.configHoles);
                  h.attrs.id = no;
                  h.attrs.lines = {};
                  h.attrs.x = pX;
                  h.attrs.y = pY;
                centrala.add(h);
              }
            }
            layerCentrala.draw()
            layerCentrala.add(centrala);
            v.stage.add(layerCentrala);
          }

        }

      // --------------------------------------- Moduły

        if (Object.keys(modules).length > 0) {
          var i = 0;
          var j = 0;

          Object.values(modules).forEach((module) => {
            var tmpCanvas = module;
          //   var modulCanvas = document.getElementById("modul");
          //   var modulCTX = modulCanvas.getContext("2d");

            if (!this.eyes.includes("modul-" + j)) {

              module.places.forEach((place) => {
                var layerModul = new Konva.Layer();

                if (place.scianka === this.widok) {
                  modX = place.wspX;
                  modY = place.wspY;

                  let newModulWidth = (layerObudowa.canvas.width * tmpCanvas.szerokosc) / szerokoscObudowy
                  let newModulHeight = (layerObudowa.canvas.height * tmpCanvas.wysokosc) / wysokoscObudowy

                  // console.log('-------------------------')
                  // console.log('newModulWidth', newModulWidth)
                  // console.log('newModulHeight', newModulHeight)
                  // console.log('-------------------------')


                  // if (szerokoscObudowy >= wysokoscObudowy) {
                  //   wsp = layerObudowa.canvas.width / szerokoscObudowy;
                  //   newModulHeight = tmpCanvas.wysokosc * wsp;
                  // } else {
                  //   wsp = layerObudowa.canvas.height / wysokoscObudowy;
                  //   newModulWidth = tmpCanvas.szerokosc * wsp;
                  // }
                  if (szerokoscObudowy >= wysokoscObudowy) {
                    // wsp = layerObudowa.canvas.width / szerokoscObudowy;
                    wsp = width / szerokoscObudowy; // dodane
                    newModulWidth = tmpCanvas.szerokosc * wsp;
                    newModulHeight = tmpCanvas.wysokosc * wsp; // dodane

                  } else {
                    // wsp = layerObudowa.canvas.height / wysokoscObudowy;
                    wsp = height / wysokoscObudowy;
                    newModulHeight = tmpCanvas.wysokosc * wsp;
                    newModulWidth = tmpCanvas.szerokosc * wsp;
                  }

                  // console.log('===========================')
                  // console.log('layerObudowa.canvas.width', layerObudowa.canvas.width)
                  // console.log('layerObudowa.canvas.height', layerObudowa.canvas.height)
                  // console.log('-------------------------')
                  // console.log('szerokoscObudowy', szerokoscObudowy)
                  // console.log('wysokoscObudowy', wysokoscObudowy)
                  // console.log('-------------------------')
                  // console.log('modul.szerokosc', tmpCanvas.szerokosc)
                  // console.log('modul.wysokosc', tmpCanvas.wysokosc)
                  // console.log('-------------------------')
                  // console.log('newModulWidth', newModulWidth)
                  // console.log('newModulHeight', newModulHeight)
                  // console.log('-------------------------')

            // if (szerokoscObudowy >= wysokoscObudowy) {
            //   // wsp = layerObudowa.canvas.width / szerokoscObudowy;
            //   wsp = width / szerokoscObudowy; // dodane
            //   newCentralkaWidth = controlPanel.szerokosc * wsp;
            //   newCentralkaHeight = controlPanel.wysokosc * wsp; // dodane

            // } else {
            //   // wsp = layerObudowa.canvas.height / wysokoscObudowy;
            //   wsp = height / wysokoscObudowy;
            //   newCentralkaHeight = controlPanel.wysokosc * wsp;
            //   newCentralkaWidth = controlPanel.szerokosc * wsp;
            // }
                  // console.log('wsp', wsp)

                  // let newModulWidth =
                  //   (layerObudowa.canvas.width * tmpCanvas.szerokosc) /
                  //   enclosures.szerokosc;
                  // let newModulHeight =
                  //   (layerObudowa.canvas.height * tmpCanvas.wysokosc) /
                  //   enclosures.wysokosc;

                  // if (enclosures.szerokosc >= enclosures.wysokosc) {
                  //   wsp = layerObudowa.canvas.width / enclosures.szerokosc;
                  //   newModulHeight = tmpCanvas.wysokosc * wsp;
                  // } else {
                  //   wsp = layerObudowa.canvas.height / enclosures.wysokosc;
                  //   newModulWidth = tmpCanvas.szerokosc * wsp;
                  // }

                  var obrot = 0
                  if (place.o0 === 1 || place.o0 === "1") {
                    obrot = 0;
                  } else if (place.o90 === 1 || place.o90 === "1") {
                    obrot = 90;
                  } else if (place.o180 === 1 || place.o180 === "1") {
                    obrot = 180;
                  } else if (place.o270 === 1 || place.o270 === "1") {
                    obrot = 270;
                  }

                  var pcbX = Number(modX * wsp) - Number(tmpCanvas.p1x * wsp) // + Number(this.odchylkaX * wsp);
                  var pcbY = Number(modY * wsp) - Number(tmpCanvas.p1y * wsp) // + Number(this.odchylkaY * wsp);

                  console.log('-------------------------')
                  console.log('pcbX', pcbX)
                  console.log('pcbY', pcbY)
                  console.log('-------------------------')

                  let module = new Konva.Group({
                    name: 'module',
                    x: Number(pcbX),
                    y: Number(pcbY),
                    rotation: obrot,
                    width: Number(newModulWidth),
                    height: Number(newModulHeight),
                    draggable: false
                  })
                  .add (new Konva.Rect({
                      x: Number(0),
                      y: Number(0),
                      width: Number(newModulWidth),
                      height: Number(newModulHeight),
                      fill: "rgba(" + kolorModul[i] + ")"
                    })
                  )

                  for (var no = 1; no < 7; no++) {
                    if (
                      Number(tmpCanvas["p" + no + "x"]) === 0 &&
                      Number(tmpCanvas["p" + no + "y"]) === 0
                    ) {
                    } else {
                      var pX =
                        Number(tmpCanvas["p" + no + "x"]) * Number(wsp); // + centralka[controlPanel].odchylkaX
                      var pY =
                        Number(tmpCanvas["p" + no + "y"]) * Number(wsp);

                      let h = new Konva.Circle(v.configHoles);
                        h.attrs.id = no;
                        h.attrs.lines = {};
                        h.attrs.x = pX;
                        h.attrs.y = pY;
                      module.add(h);
                    }
                  }
                  layerModul.draw()
                  layerModul.add(module);
                  v.stage.add(layerModul);
                }
              })
              i++;
            } else {
              i++;
            }
            j++;
          })
        }

      // ======================================================================== OLD
      //--------------------------- Obudowa



        // if (Object.keys(enclosures).length > 0) {
        //   // var strDataURI = 'http://localhost:8081/assets/AWO000.jpg'
        //   var strDataURI =
        //     process.env.VUE_APP_ROOT_IMG + "" + enclosures.symbol + ".jpg";

        //   var obudowaCanvas = document.getElementById("obudowa");
        //   var oCtx = obudowaCanvas.getContext("2d");

        //   var img = new Image();
        //   img.src = strDataURI;

        //   var x = 0;
        //   var y = 0;

        //   img.onload = function () {
        //     let loadedImageWidth = img.width;
        //     let loadedImageHeight = img.height;
        //     let scale_factor = Math.min(
        //       obudowaCanvas.width / img.width,
        //       obudowaCanvas.height / img.height
        //     );

        //     let newWidth = img.width * scale_factor;
        //     let newHeight = img.height * scale_factor;

        //     oCtx.clearRect(0, 0, obudowaCanvas.width, obudowaCanvas.height);
        //     oCtx.imageSmoothingEnabled = false;
        //     oCtx.drawImage(img, x, y, newWidth, newHeight);
        //   };
        // } // end Obudowa

        //--------------------------- Centrala

        // let radius = 5;
        // let wsp = 0;
        // var modX = 0;
        // var modY = 0;

        // if (
        //   Object.keys(controlPanel).length > 0 &&
        //   !this.eyes.includes("centrala")
        // ) {
        //   var environmentCanvas = document.getElementById("centrala");
        //   var ctx = environmentCanvas.getContext("2d");

        //   let newCentralkaWidth =
        //     (obudowaCanvas.width * controlPanel.szerokosc) /
        //     enclosures.szerokosc;
        //   let newCentralkaHeight =
        //     (obudowaCanvas.height * controlPanel.wysokosc) /
        //     enclosures.wysokosc;

        //   if (enclosures.szerokosc >= enclosures.wysokosc) {
        //     wsp = obudowaCanvas.width / enclosures.szerokosc;
        //     newCentralkaHeight = controlPanel.wysokosc * wsp;
        //   } else {
        //     wsp = obudowaCanvas.height / enclosures.wysokosc;
        //     newCentralkaWidth = controlPanel.szerokosc * wsp;
        //   }

        //   ctx.beginPath();
        //   ctx.globalAlpha = 1.0;
        //   ctx.lineWidth = 0;
        //   ctx.fillStyle = "rgba(" + kolorCentrala[0] + ")";

        //   if (enclosures.wspX && enclosures.wspY) {
        //     modX = enclosures.wspX;
        //     modY = enclosures.wspY;
        //   } else {
        //     modX = controlPanel.wspX;
        //     modY = controlPanel.wspY;
        //   }

        //   var pcbX =
        //     Number(modX * wsp) -
        //     Number(controlPanel.p1x * wsp) +
        //     Number(this.odchylkaX * wsp);
        //   var pcbY =
        //     Number(modY * wsp) -
        //     Number(controlPanel.p1y * wsp) +
        //     Number(this.odchylkaY * wsp);

        //   ctx.fillRect(pcbX, pcbY, newCentralkaWidth, newCentralkaHeight);
        //   ctx.lineWidth = 1;
        //   ctx.strokeStyle = "rgba(255, 0, 0, 1)";
        //   ctx.closePath();
        //   ctx.stroke();

        //   [1, 2, 3, 4, 5, 6].forEach((no) => {
        //     if (
        //       Number(controlPanel["p" + no + "x"]) === 0 &&
        //       Number(controlPanel["p" + no + "y"]) === 0
        //     ) {
        //     } else {
        //       ctx.beginPath();
        //       var pX =
        //         Number(pcbX) +
        //         Number(controlPanel["p" + no + "x"]) * Number(wsp);
        //       var pY =
        //         Number(pcbY) +
        //         Number(controlPanel["p" + no + "y"]) * Number(wsp);

        //       ctx.arc(pX, pY, radius, 0, Math.PI * 2, true);
        //       ctx.fillStyle = "red";
        //       ctx.fill();
        //       ctx.lineWidth = 1;
        //       ctx.strokeStyle = "black";
        //       ctx.stroke();
        //     }
        //   });
        // } // end centrala

        //--------------------------- Moduły

        // console.log(this.compIndexModul)
        // console.log('inputData', this.inputData.indexModul)
        // console.log('inputData', Object.keys(this.inputData.indexModul).length)

        if (Object.keys(modules).length > 0) {
          // var i = 0;
          // var j = 0;
          // Object.values(modules).forEach((module) => {
          //   var tmpCanvas = module;
          //   var modulCanvas = document.getElementById("modul");
          //   var modulCTX = modulCanvas.getContext("2d");

          //   if (!this.eyes.includes("modul-" + j)) {
          //     module.places.forEach((place) => {
          //       modulCTX.save();

          //       let newModulWidth =
          //         (obudowaCanvas.width * tmpCanvas.szerokosc) /
          //         enclosures.szerokosc;
          //       let newModulHeight =
          //         (obudowaCanvas.height * tmpCanvas.wysokosc) /
          //         enclosures.wysokosc;

          //       if (enclosures.szerokosc >= enclosures.wysokosc) {
          //         wsp = obudowaCanvas.width / enclosures.szerokosc;
          //         newModulHeight = tmpCanvas.wysokosc * wsp;
          //       } else {
          //         wsp = obudowaCanvas.height / enclosures.wysokosc;
          //         newModulWidth = tmpCanvas.szerokosc * wsp;
          //       }

          //       modulCTX.beginPath();
          //       modulCTX.globalAlpha = 1.0;
          //       modulCTX.lineWidth = 0;
          //       modulCTX.fillStyle = "rgba(" + kolorModul[i] + ")";

          //       if (enclosures.wspX && enclosures.wspY) {
          //         modX = enclosures.wspX;
          //         modY = enclosures.wspY;
          //       } else {
          //         modX = place.wspX;
          //         modY = place.wspY;
          //       }

          //       var modulX =
          //         Number(modX * wsp) -
          //         Number(tmpCanvas.p1x * wsp) +
          //         Number(this.odchylkaX * wsp);
          //       var modulY =
          //         Number(modY * wsp) -
          //         Number(tmpCanvas.p1y * wsp) +
          //         Number(this.odchylkaY * wsp);

          //       if (place.o0 === 1 || place.o0 === "1") {
          //         rotation = 0;
          //       } else if (place.o90 === 1 || place.o90 === "1") {
          //         rotation = 90;
          //       }

          //       modulCTX.translate(
          //         modulX + newModulWidth / 2,
          //         modulY + newModulHeight / 2
          //       );
          //       modulCTX.rotate((rotation * Math.PI) / 180);
          //       modulCTX.translate(
          //         -(modulX + newModulWidth / 2),
          //         -(modulY + newModulHeight / 2)
          //       );

          //       modulCTX.fillRect(modulX, modulY, newModulWidth, newModulHeight);
          //       modulCTX.fillRect(modulX, modulY, newModulWidth, newModulHeight);

          //       modulCTX.lineWidth = 1;
          //       modulCTX.strokeStyle = "rgba(255, 0, 0, 0.4)";
          //       modulCTX.closePath();
          //       modulCTX.stroke();

          //       [1, 2, 3, 4, 5, 6].forEach((no) => {
          //         if (
          //           Number(tmpCanvas["p" + no + "x"]) === 0 &&
          //           Number(tmpCanvas["p" + no + "y"]) === 0
          //         ) {
          //         } else {
          //           modulCTX.beginPath();
          //           var pX =
          //             Number(modulX) +
          //             Number(tmpCanvas["p" + no + "x"]) * Number(wsp);
          //           var pY =
          //             Number(modulY) +
          //             Number(tmpCanvas["p" + no + "y"]) * Number(wsp);

          //           modulCTX.arc(pX, pY, radius, 0, Math.PI * 2, true);
          //           modulCTX.fillStyle = "red";
          //           modulCTX.fill();
          //           modulCTX.lineWidth = 1;
          //           modulCTX.strokeStyle = "black";
          //           modulCTX.closePath();
          //           modulCTX.stroke();
          //         }
          //       });
          //       modulCTX.restore();
          //     });
          //     i++;
          //   } else {
          //     i++;
          //   }
          //   j++;
          // });
        } // if Object.keys(modules).length
      } // if this.selectedElements && Object.keys(this.selectedElements).length
    } // viewMontaz

  }
};
</script>

<style>

.hello input {
  width: 135px;
}
.hello {
  height: 100%;
}

.wrapper {
  display: table;
  padding: 0;
  width: 100%;
  height: 100%;
  /* position: absolute; */
}

.container {
  /* display: table-cell;
  vertical-align: middle; */
  display: block;
  margin-top: 20px;
}

.canvas-container {
  position: relative;
  /* max-width: 1024px;
  min-width: 320px; */
  margin: 0 auto;
  width: 100%;
  height: 100%;
  text-align: left;
}

#obudowa {
  width: 100%;
  height: auto;
  z-index: 0;
}
#centrala {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

#terrain {
  width: 100%;
  height: auto;
  /* background-color: pink; */
  z-index: 0;
}

#player {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

#environment {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}

#modul {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
}

#hud {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
}

#resize-me span {
  background: #000;
  color: #fff;
  font-family: arial, sans-serif;
  text-align: center;
  font-weight: bold;
  padding: 5px 40px;
  line-height: 2rem;
  width: 200px;
  position: absolute;
  top: 30px;
  right: -80px;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

#resize-me {
  position: absolute;
  top: 0;
  right: 0;
  width: 200px;
  overflow: hidden;
  height: 200px;
  z-index: 5;
}
</style>



// WEBPACK FOOTER //
// src/components/Wizualizacja.vue